module.exports = __webpack_public_path__ + "static/media/use_esim_jpn3.b46db069.png";